<!-- Split hero — dev2 Register pattern (initials / number-ones): copy +
     composer on the left, square-edged photograph on the right, no overlay.
     The BYO composer is the page's primary action, so it sits where the
     Initials page puts its monogram input. -->
<section class="hero">
  <div class="wrap hero-grid">
    <div class="hero-copy">
      <span class="eyebrow">{{ series.preRelease && !saleOpen ? 'Pre-release' : series.preRelease ? 'On sale now' : 'New release' }} &middot; {{ series.yearDisplay }} series</span>
      <h1>{{ heading || series.headlineCopy || ('The ' + series.yearDisplay + ' series.') }}</h1>
      <p class="lede" *ngIf="series.subCopy">{{ series.subCopy }}</p>

      <div class="composer">
        <div class="composer-head">
          <span class="composer-title">Build your own &lsquo;{{ series.yearDisplay }}&rsquo; plate</span>
          <span class="composer-sub" *ngIf="series.combinationsCount">
            From {{ (series.combinationsCount / 1000000) | number:'1.1-1' }} million combinations
          </span>
        </div>
        <pla-new-release-byo
          surface="light"
          [year]="series.yearDisplay"
          (searchSubmitted)="onByoSearch($event)">
        </pla-new-release-byo>
      </div>
    </div>

    <figure class="hero-fig" *ngIf="series.heroImagePath">
      <img class="hero-img" [src]="series.heroImagePath"
           [alt]="'A car wearing a ' + series.yearDisplay + '-series registration'" />
    </figure>
  </div>

  <!-- Release facts — the Register hero-stats row. Only verified values
       render; anything the source can't fact-check is omitted. -->
  <div class="wrap" *ngIf="series.releasedDate || series.combinationsCount || series.vehiclesFromDate || series.v750Retention">
    <div class="hero-stats">
      <div class="s" *ngIf="series.releasedDate">
        <div class="n">{{ series.releasedDate }}</div>
        <div class="l">{{ series.releasedLabel || 'Released' }}</div>
      </div>
      <div class="s" *ngIf="series.combinationsCount">
        <div class="n">~{{ (series.combinationsCount / 1000000) | number:'1.1-1' }}<em>m</em></div>
        <div class="l">New combinations</div>
      </div>
      <div class="s" *ngIf="series.vehiclesFromDate">
        <div class="n">{{ series.vehiclesFromDate }}</div>
        <div class="l">For vehicles from</div>
      </div>
      <div class="s" *ngIf="series.v750Retention">
        <div class="n">{{ series.v750Retention }}</div>
        <div class="l">V750 retention</div>
      </div>
    </div>
  </div>
</section>

<pla-new-release-ticker
  *ngIf="ticker?.entries?.length"
  [label]="ticker.label"
  [mode]="ticker.mode"
  [entries]="ticker.entries">
</pla-new-release-ticker>
